import drink1 from "./menu-1.jpg";
import drink2 from "./menu-2.jpg";
import drink3 from "./menu-3.jpg";
import drink4 from "./menu-4.jpg";



const specialty = [
    {
      src: drink1,
      alt: "Drink 1",
      title: "Cà phê Capuchino",
      price: "$2.90",
      content:
        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."
    },
    {
      src: drink2,
      alt: "Cà phê Mocha",
      title: "Cà phê Mocha",
      price: "$2.90",
      content:
        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."
    },
    {
      src: drink3,
      alt: "Cà phê Macchiato",
      title: "Cà phê Macchiato",
      price: "$2.90",
      content:
        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."
    },
    {
      src: drink4,
      alt: "Cà phê Latte",
      title: "Cà phê Latte",
      price: "$2.90",
      content:
        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."
    },
  ];
  
  export default specialty;
  
